module.exports = __webpack_public_path__ + "static/assets/e158cd955d38d8bcc8b9ca69e19f8196.svg";